import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, Col, Row, Table, CardHeader, Label, Input, Button, FormGroup, Form} from 'reactstrap';
import connect from "react-redux/es/connect/connect";
import {Link} from "react-router-dom";
import {FormBuilder, FieldControl, FieldGroup} from "react-reactive-form";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';
import 'moment/locale/pt-br';
import {MdSearch, MdAssignmentTurnedIn} from "react-icons/lib/md";
import API from "../../resources/index";

class AuditPage extends React.Component {
    auditResource = API.auditResource;

    auditSearchForm = FormBuilder.group({
        date: [''],
        company: [''],
        auditor: [''],
    });

    constructor() {
        super();
        this.state = {
            audits: [],
        }
    }

    getAudits = (params = {}) => {
        this.auditResource.query(
            {
                keys: {
                    expand: [
                        'auditor',
                        'company',
                        'company.manager',
                    ],
                    ...params
                }
            }
        )
            .then(response => {
                if (response.status === 200) {
                    this.setState({audits: response.data});
                }
            })
    };

    onSearch = (event) => {
        event.preventDefault();
        this.getAudits(this.auditSearchForm.value);

    };

    componentDidMount() {
        this.getAudits();
    }

    handleDayChange = (selectedDay, modifiers, dayPickerInput) => {
        const input = dayPickerInput.getInput();
        this.auditSearchForm.controls.date.setValue(input.value.trim());
    };

    render() {
        return <Page
            title="Auditorias Realizadas"
            icon='MdAssignment'
            // breadcrumbs={[{name: 'Auditorias Realizadas', active: true}]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardBody>
                            <FieldGroup
                                control={this.auditSearchForm}
                                render={({get, invalid}) => (
                                    <Form onSubmit={this.onSearch}>
                                        <Row>
                                            <Col>
                                                <FieldControl
                                                    name="date"
                                                    render={({handler, touched, hasError, meta}) => (
                                                        <FormGroup>
                                                            <Label style={{width: 100 + '%'}}
                                                                   for="date">{meta.label}</Label>
                                                            <DayPickerInput
                                                                inputProps={{
                                                                    id: "date",
                                                                    className: 'form-control',
                                                                    autoComplete: 'off',
                                                                    ...handler()
                                                                }}
                                                                onDayChange={this.handleDayChange}
                                                                {...handler()}
                                                                formatDate={formatDate}
                                                                parseDate={parseDate}
                                                                placeholder='dd/mm/aaaa'
                                                                dayPickerProps={{
                                                                    locale: 'pt-br',
                                                                    localeUtils: MomentLocaleUtils,
                                                                }}/>
                                                            <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                        </FormGroup>
                                                    )}
                                                    meta={{label: "Data"}}
                                                />
                                            </Col>
                                            <Col>
                                                <FieldControl
                                                    name="company"
                                                    render={({handler, touched, hasError, meta}) => (
                                                        <FormGroup>
                                                            <Label for="company">{meta.label}</Label>
                                                            <Input type="text" id="company" {...handler()}/>
                                                            <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                        </FormGroup>
                                                    )}
                                                    meta={{label: "Empresa"}}
                                                />
                                            </Col>
                                            <Col>
                                                <FieldControl
                                                    name="auditor"
                                                    render={({handler, touched, hasError, meta}) => (
                                                        <FormGroup>
                                                            <Label for="auditor">{meta.label}</Label>
                                                            <Input type="text" id="auditor" {...handler()}/>
                                                            <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                        </FormGroup>
                                                    )}
                                                    meta={{label: "Auditor"}}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='offset-5'>
                                                <Button color="secondary" disabled={invalid}>
                                                    <MdSearch/> Buscar
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <h4 className='float-left table-title mt-1'>Auditorias Realizadas</h4>
                            <Link className='btn btn-secondary float-right'
                                  to="/audits/form"><MdAssignmentTurnedIn/> Realizar Auditoria</Link>
                        </CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Feito em</th>
                                    <th>Auditor</th>
                                    <th>Observação</th>
                                    <th>Razão Social / Nome Fantasia</th>
                                    <th>Gestor</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.audits.map(audit => {
                                    return <tr key={audit.id}>
                                        <td>
                                            {(new Date(audit.created_at)).toLocaleDateString('pt-br')}
                                        </td>
                                        <td>
                                            {audit.auditor && audit.auditor.name}
                                        </td>
                                        <td>
                                            {audit.observation}
                                        </td>
                                        <td>{audit.company.social_name}</td>
                                        <td>{audit.company.manager && audit.company.manager.name}</td>
                                    </tr>
                                })}

                                {!this.state.audits.length && <tr>
                                    <td colSpan={5} style={{textAlign: 'center'}}>Não há itens para
                                        exibição
                                    </td>
                                </tr>}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default connect(mapStateToProps)(AuditPage);



// WEBPACK FOOTER //
// ./src/pages/audit/AuditPage.js